import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  provide_withdrawal_rights_flag: {
    name: 'Does the AIF provide investors with withdrawal or redemption rights in the ordinary course?',
    order: 209,
    letter: 'A'
  },
  investor_redemption_frequency: {
    name: 'What is the frequency of investor redemptions?',
    order: 210,
    letter: 'A'
  },
  investor_redemption_notice_period: {
    name: 'What is the notice period required for redemptions in days?',
    order: 211,
    letter: 'A'
  },
  investor_redemption_lockup_period: {
    name: "What is the investor 'lock-up' period in days?",
    order: 212,
    letter: 'A'
  }
};

export function LiquidityRedemption2({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_LIQUIDITY_PROFILE,
    onChangeFund,
    schema: schema.INVESTOR_LIQUIDITY_PROFILE,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTOR_LIQUIDITY_PROFILE?.field_names || [],
    columnLables,
    isMultiFunds,
    funds,
    tableName: 'INVESTOR_LIQUIDITY_PROFILE'
  });

  return (
    <Table
      id="fca-reporttables-liquidity-redemption-2-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
